import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  unreadRooms: [],
  unreadNotification: 0,
};

const commonSlice = createSlice({
  name: "commonSlice",
  initialState,
  //   reducer needs a map
  reducers: {
    setUnreadRooms(state, action) {
      state.unreadRooms = action.payload;
    },
    saveUnReadNotification(state, action) {
      state.unreadNotification = action.payload;
    },
  },
});

export const { setUnreadRooms, saveUnReadNotification } = commonSlice.actions;

export default commonSlice.reducer;
